import React, {useContext, useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {CurrentStatus} from "src/components/healthDashboard/CurrentStatus";
import {HistoricalStatus} from "src/components/healthDashboard/HistoricalStatus";
import {isSpectrumHubSite} from "src/common/utils/dashboardUtils";
import {GlobalContext} from "src/context/GlobalProvider";
import {fetchMetadataAction} from "src/context/actions/MetadataActions";
import {fetchEventsAction} from "src/context/actions/EventActions";
import {fetchSectionsAction} from "src/context/actions/SectionActions";
import {KatIcon, KatStatusindicator} from "@amzn/katal-react";
import {ErrorView} from "src/components/error/ErrorView";
import {RegionSelector} from "src/components/healthDashboard/RegionSelector";
import {OperationSearchModal} from "src/components/healthDashboard/editableView/OperationSearchModal";

export const HealthDashboard = () => {
    const {t} = useTranslation();

    const [isOperationFinderModalVisible, setOperationFinderModalVisible] = React.useState(false);
    const {
        sectionsDispatch,
        sectionsState,
        metadataDispatch,
        metadataState,
        eventDispatch,
        eventState
    } = useContext(GlobalContext);

    const isSpectrumHub: boolean = isSpectrumHubSite();

    useEffect(() => {
        fetchSectionsAction(sectionsDispatch);
        if (isSpectrumHub) {
            fetchMetadataAction(metadataDispatch);
        }
        fetchEventsAction(eventDispatch, isSpectrumHub);
    }, [])

    if (sectionsState.loading || metadataState.loading || eventState.loading) {
        return <KatStatusindicator label={t("Loading")} variant="loading"/>;
    }
    // Show error:
    // If any state has non null error or,
    // Section data or Event data is empty or,
    // Metadata is empty when in editable view site.
    else if ((sectionsState.error || metadataState.error || eventState.error)
        || !(sectionsState.data && eventState.data
            && (metadataState.data || !isSpectrumHub))) {
        return <ErrorView message="Failed to fetch content. Most probably Lambda reviving from cold start. Please retry."/>;
    }

    return (
        <div id="health-dashboard">
            <h1 id="health-dashboard-title">
                {t("Selling Partner API - Health Dashboard")}
            </h1>
            <div className="spacer-small" />
            <div className="top-row">
                <RegionSelector/>
                {isSpectrumHub ? <KatIcon id="search-operation" name="search"
                                          onClick={() => setOperationFinderModalVisible(true)}/> : null}
            </div>
            <CurrentStatus events={eventState.data} sections={sectionsState.data} metadata={metadataState.data}/>
            <HistoricalStatus events={eventState.data}/>
            {isOperationFinderModalVisible ? <OperationSearchModal sections={sectionsState.data.sections}
                                                                   setVisible={setOperationFinderModalVisible}/>: null}
        </div>
    );
}
